import axios from 'axios'

export const rewardOCX = async (ada: number) =>
  await axios.post(`${process.env.REACT_APP_ADA_POOLS_API_URL}/reward/ada`, ada)
